import { render, staticRenderFns } from "./InputEditorModal.vue?vue&type=template&id=88a1a024&style=background-color%3Awhite%3B"
import script from "./InputEditorModal.vue?vue&type=script&lang=js"
export * from "./InputEditorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports